import type { ActionStatus } from '../types/actions';

const transitions: Record<ActionStatus, ActionStatus[]> = {
  draft: ['ready_to_submit'],
  ready_to_submit: ['draft', 'submitted'],
  submitted: ['acknowledged', 'in_progress', 'disputed'],
  acknowledged: ['in_progress', 'rectification_claimed', 'disputed'],
  in_progress: ['rectification_claimed', 'disputed'],
  rectification_claimed: ['in_progress', 'disputed'],
  verified_closed: [],
  waived: [],
  disputed: ['in_progress', 'rectification_claimed'],
};

const postSubmissionStatuses: ActionStatus[] = [
  'submitted',
  'acknowledged',
  'in_progress',
  'rectification_claimed',
  'disputed',
];

export function getAllowedActionTransitions(status: ActionStatus): ActionStatus[] {
  return transitions[status];
}

export function canTransitionAction(from: ActionStatus, to: ActionStatus): boolean {
  return transitions[from].includes(to);
}

export function canRecordBuilderResponse(status: ActionStatus): boolean {
  return postSubmissionStatuses.includes(status);
}

export function canRecordFollowUp(status: ActionStatus): boolean {
  return postSubmissionStatuses.includes(status);
}

export function actionStatusLabel(status: ActionStatus): string {
  return status.replaceAll('_', ' ');
}

export function actionTransitionLabel(status: ActionStatus): string {
  switch (status) {
    case 'draft':
      return 'Move back to draft';
    case 'ready_to_submit':
      return 'Mark ready to submit';
    case 'submitted':
      return 'Mark as submitted';
    case 'acknowledged':
      return 'Mark acknowledged';
    case 'in_progress':
      return 'Mark in progress';
    case 'rectification_claimed':
      return 'Builder says rectified';
    case 'disputed':
      return 'Mark disputed';
    case 'verified_closed':
      return 'Verified closed';
    case 'waived':
      return 'Waived';
  }
}

export function isActionOverdue(dueDate: string, status: ActionStatus, today = new Date()): boolean {
  if (['verified_closed', 'waived'].includes(status)) {
    return false;
  }

  const due = new Date(`${dueDate}T23:59:59`);
  return due.getTime() < today.getTime();
}
